<template>
    <router-link :to="link" class="bg-white hover:bg-blue/5 group rounded-md shadow-md p-4 transition-all ease-in-out duration-500">
        <div
            class="text-white p-4 rounded-md h-[250px] flex flex-col justify-between bg-cover bg-no-repeat bg-center"
            :style="'background-image: url(' + $asset('/hkcm/images/video-cover-play.png', 'public') + ')'"
        >
            <div>
                <p class="text-xxs">
                    {{ $moment(data.published_at).format('DD.MM.YYYY') }}
                </p>
            </div>
            <div class="flex flex-col lg:flex-row gap-4 lg:items-center">
                <div class="text-white w-[50px] h-[50px] flex-shrink-0">
                    <img :alt="$translate(data.product.name)" class="w-full h-full object-contain" ref="svg" :src="data.product.image.replace('.png', '-gradient.png')" />
                </div>
                <div>
                    <p class="text-xxs">
                        {{ $translate(data.contentstreamType.title) }}
                    </p>
                    <strong>
                        {{ $translate(data.product.name) }}
                    </strong>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['data', 'page', 'type', 'query_params'],

    computed: {
        background() {
            let backgroundColor = this.data.product.productGroups.data[0].productCategories.data[0].background_color;
            let backgroundGradient = this.data.product.productGroups.data[0].productCategories.data[0].background_gradient;

            return 'linear-gradient(to bottom, ' + backgroundColor + ' 0%, ' + backgroundGradient + ' 100%)';
        },

        link() {
            if (this?.query_params) {
                return `/dashboard/videoanalysis/${this?.data?.id}?${this?.query_params?.toString()}`;
            } else {
                return `/dashboard/videoanalysis/${this?.data?.id}`;
            }
        }
    }
};
</script>

<style scoped>
.icon {
    background: v-bind(background);
}
</style>
